import * as MobX from "mobx";

// Custom
import { SnagNoteModelDTO } from "Custom/Models/DashboardModels/SnagModel";
import { BaseStore } from "./BaseStore";
import { Stores } from "../Stores";

export class SnagNoteStore extends BaseStore {
    @MobX.observable
    private snagNotes: SnagNoteModelDTO[] = [];

    @MobX.observable
    private tmpNotes: string[] = [];

    @MobX.action
    public populateSnagNotes(snagNotes: SnagNoteModelDTO[]) {
        this.snagNotes = snagNotes;
    }

    @MobX.computed
    public get getSnagNotes(): SnagNoteModelDTO[] {
        return this.snagNotes;
    }

    @MobX.action
    public populateTmpNotes(files: string[]) {
        this.tmpNotes = files;
    }

    @MobX.computed
    public get getTmpNotes(): string[] {
        return this.tmpNotes;
    }

    public Init(stores: Stores) {}
}
